/**
 * BotanicalSprig — watercolor willow branch used across the Planner.
 *
 * We render Kelly's uploaded PNG (public/willow-branch.png) rather than
 * inline SVG so the piece keeps its hand-painted texture. The wrapper is
 * pointer-events-none by default so nothing sitting under a decorative
 * branch ever gets its click hijacked.
 *
 * Props:
 *   size     px width (height auto — the source PNG is 3:2 landscape)
 *   opacity  0-1, kept low (0.12-0.4) for background use
 *   flip     horizontal mirror
 *   rotate   deg
 */
export default function BotanicalSprig({
  className = "",
  opacity = 0.35,
  flip = false,
  rotate = 0,
  size = 200,
  "data-testid": testid,
}) {
  const style = {
    width: size,
    height: "auto",
    transform: `${flip ? "scaleX(-1)" : ""} rotate(${rotate}deg)`.trim(),
    transformOrigin: "center",
    opacity,
    pointerEvents: "none",
    userSelect: "none",
  };
  return (
    <img
      src="/willow-branch.png"
      alt=""
      aria-hidden="true"
      draggable={false}
      className={className}
      style={style}
      data-testid={testid}
    />
  );
}
